import { HStack, Box, Link, StackProps } from "@chakra-ui/react";

export interface SocialMediaLink {
  platform: string;
  url: string;
}

const socialMediaLinks: SocialMediaLink[] = [
  {
    platform: "Youtube",
    url: "https://www.youtube.com/globalcomix",
  },
  {
    platform: "Discord",
    url: "https://discord.gg/9AZ9XfvvcG",
  },
  {
    platform: "TikTok",
    url: "https://www.tiktok.com/@globalcomix",
  },
  {
    platform: "X",
    url: "https://x.com/globalcomix?lang=en",
  },
  {
    platform: "Instagram",
    url: "https://www.instagram.com/globalcomix/",
  },
];

export function SocialMediaIcons({
  mediaLinks,
  containerProps,
  black,
}: {
  mediaLinks?: SocialMediaLink[];
  containerProps?: StackProps;
  black?: boolean;
}) {
  const links = mediaLinks || socialMediaLinks;
  return (
    <HStack
      spacing={4}
      justify="space-around"
      width="100%"
      maxW="400px"
      py="8px"
      {...containerProps}
    >
      {links.map(({ platform, url }) => (
        <Link
          key={platform}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
          aria-label={`Visit our ${platform} page`}
        >
          <Box
            bgImage={`url(${window.gc.global.assets_url}/static/images/web-ui/social-icons/${platform.toLowerCase()}.svg)`}
            filter={black ? "brightness(0)" : "none"}
            bgSize="contain"
            bgPosition="center"
            bgRepeat="no-repeat"
            width="24px"
            height="24px"
            _hover={{
              bgImage: `url(${window.gc.global.assets_url}/static/images/web-ui/social-icons/${platform.toLowerCase()}-hover.svg)`,
            }}
            transition="all 0.3s"
            role="img"
            aria-label={`${platform} icon`}
          />
        </Link>
      ))}
    </HStack>
  );
}
